export default "__VITE_PUBLIC_ASSET__bcd853ec__"